import { useOutletContext } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/esm/Button.js'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import Icon from '../../../../components/Icon'

import { insertGroup } from '../../../../state/actions/groupActions'
import { addNotification, NotificationTypes } from '../../../../state/actions/notificationActions'

import { businessEntityDictionarySignal } from '../../../../state/signals/businessEntitySignals.js'

const NewGroupModal = function ({ showSignal, cancelAdd, selectedParentBusinessEntityIdSignal, showModalSelectParentSignal }) {

	const { user, config, accessToken, permissionMasks, permissions } = useOutletContext()

	const nameSignal = useSignal('')

	const updateName = (event) => {
		nameSignal.value = event.target.value
	}

	const toggleChangeParent = function () {
		showSignal.value = false
		showModalSelectParentSignal.value = true
	}

	const validGroupNameComputed = useComputed(
		() => {
			return nameSignal.value && typeof nameSignal.value == 'string' && nameSignal.value.length > 0 && nameSignal.value.length <= 50
		}
	)

	/* Request: {
	"isActive": false,
	"lastUpdatedAt": null,
	"name": "Test group to intercept request",
	"parentBusinessEntityId": "8647",
	"properties": []
	}*/

	const submitForm = () => {
		const parentId = selectedParentBusinessEntityIdSignal.value
		const group = {
			isActive: false,
			lastUpdatedAt: null,
			name: nameSignal.value,
			parentBusinessEntityId: parentId,
			properties: []
		}
		insertGroup(parentId, group, config, accessToken).then(
			(group) => {
				addNotification(`Successfully created new group "${group.name}"`, NotificationTypes.SUCCESS, true, "New Group Created")
			}
		)
		cancelAdd()
		/*async (event) => {
			event.preventDefault()
			try {
				submitForm({
					form: event.target.form,
					//validators: validators,
					body: {
						isActive: false,
						lastUpdatedAt: null,
						name: nameSignal.value,
						parentBusinessEntityId: selectedBusinessEntitySignal.value.id,
						properties: []
					},
					successCallback: (rt) => {
						//console.log(rt)
						addNotification(`Successfully submitted new group `.concat(rt.merchant.name), NotificationTypes.SUCCESS, true)
					},
					errorCallback: (rt) => {
						//console.log(rt)
						addNotification(
							`Failed to submit new group`.concat(
								rt.messages && rt.messages.length && rt.messages.length > 0 ?
									rt.messages.join("; ") :
									''
							),
							NotificationTypes.ERROR,
							true
						)
					},
					accessToken: accessToken
				})
			}
			catch (x) {
				//window.alert("Submit form error callback: Caught exception ".x.toString())
				addNotification(`Failed to submit new group: Caught exception `.concat(x.toString()), NotificationTypes.ERROR, true)
			}
		}*/
	}

	const selectedParentBusinessEntityNameComputed = useComputed(
		() => {
			const parent = businessEntityDictionarySignal.value[selectedParentBusinessEntityIdSignal.value]
			return parent?.name ?? ''
		}
	)

	return (
		<Modal show={showSignal.value} onHide={cancelAdd}>
			<Modal.Header closeButton>
				<Modal.Title>New Group</Modal.Title>
			</Modal.Header>
			<Form>
				<div className='panel-body'>
					<Form.Group className="form-group-centered">
						<label className="col-md-3 col-xs-12 control-label">Name</label>
						<span className="col-md-6 col-xs-10">
							<input type="text" placeholder="Name this group" spellCheck={false} maxLength="50" required={true} onChange={updateName} />
						</span>
					</Form.Group>
					<Form.Group className="form-group-centered">
						<label className="col-md-3 col-xs-12 control-label">Parent</label>
						<input value={selectedParentBusinessEntityNameComputed.value} type='text' className='form-control readonly-input' id='parentOrg' name='parentOrg' required={true} disabled='disabled' />
						<label className="edit-label control-label" style={{ position: "absolute", height:"38px", width:"38px",  right: 0 }} onClick={toggleChangeParent}>
							<Icon icon="pencil" height={16} width={16} style={{ position: "absolute", right: 0, margin:"11px" }}></Icon>
						</label>
					</Form.Group>
				</div>
				<span className="button-container panel-footer float-end">
					<Button onClick={cancelAdd}>Cancel</Button>
					<Button disabled={!validGroupNameComputed.value} onClick={submitForm}>Add</Button>
				</span>
			</Form>
		</Modal>
	)
}
export default NewGroupModal